// components/PageHead.tsx
import Head from "react-helmet";

export default function PageHead({ title, description, image }: { title: string; description: string; image?: string }) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
    </Head>
  );
}
